"use client";

import React from "react";

const Testimonials: React.FC = () => {
  return (
    <section
      className="relative w-full bg-gradient-to-br from-gray-50 to-white pt-32 pb-12 sm:pt-36 sm:pb-16 overflow-hidden"
      role="region"
      aria-labelledby="testimonials-heading"
    >
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-[#ECD05B]/10 to-transparent rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#AE7D2F]/10 to-transparent rounded-full blur-3xl" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-8 lg:px-12">
        <h1
          id="testimonials-heading"
          className="
          text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 text-center
          after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:my-5
          after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          mb-8
        "
        >
          Dental Patient Testimonials
        </h1>

        <h3 className="text-xl sm:text-2xl text-gray-700 text-center mb-12">
          Read real patient testimonials of smile4me in Astoria, NY
        </h3>

        {/* Single Centered Video with gradient border */}
        <div className="max-w-4xl mx-auto">
          <div className="relative rounded-lg overflow-hidden border-[5px] border-transparent bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] p-[5px] shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="relative rounded-lg overflow-hidden bg-white">
              <div className="relative aspect-video">
                <iframe
                  src="https://www.youtube.com/embed/CsBFSUzDLqQ"
                  title="Patient Testimonial 1"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;